import React from "react";
import Reel from "../../Assets/Reel.mp4";
import "./Landing.scss";

export default class Landing extends React.Component {
  render() {
    return (
      <div className="landing-page" id="Landing" data-scroll-section>
        <div className="landing-body">
          <video
            autoPlay
            muted
            loop
            playsInline
            disablePictureInPicture
            controls={false}
            className="landing-video prevent-click"
          >
            <source src={Reel} type="video/mp4" />
          </video>
        </div>
      </div>
    );
  }
}
